/** Loading placeholder block (8.12.4 "Yuklanish (skelet)"). */
import type { ComponentProps } from 'react';
import { classNames } from '../styling/class_names';

export function Skeleton({ className, ...skeletonProps }: ComponentProps<'div'>) {
  return (
    <div
      aria-hidden
      className={classNames('animate-pulse rounded-control bg-neutral-soft', className)}
      {...skeletonProps}
    />
  );
}
